import { useEffect, useRef, useState } from 'react';
import {
  useMyNotificationsQuery,
  useMarkNotificationReadMutation,
  useMarkAllNotificationsReadMutation,
} from '../../features/notifications/notificationsApi';

export default function NotificationsBell() {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const { data } = useMyNotificationsQuery();
  const [markRead] = useMarkNotificationReadMutation();
  const [markAllRead] = useMarkAllNotificationsReadMutation();

  const notifications = data?.data ?? [];
  const unreadCount = notifications.filter((n) => !n.read_at).length;

  useEffect(() => {
    if (!open) return undefined;
    const onClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  const panel = (
    <>
      <div className="flex items-center justify-between px-4 py-3 border-b border-border">
        <p className="text-sm font-semibold text-foreground">Notifications</p>
        {unreadCount > 0 && (
          <button onClick={() => markAllRead()} className="text-xs text-accent hover:underline">Mark all read</button>
        )}
      </div>
      {notifications.length === 0 ? (
        <p className="px-4 py-6 text-sm text-foreground-muted text-center">No notifications yet.</p>
      ) : (
        <div className="divide-y divide-border">
          {notifications.map((n) => (
            <button
              key={n.id}
              onClick={() => !n.read_at && markRead(n.id)}
              className={`w-full text-left px-4 py-3 hover:bg-background-elevated/50 transition-colors ${!n.read_at ? 'bg-accent-soft/40' : ''}`}
            >
              <p className="text-sm font-medium text-foreground">{n.title}</p>
              <p className="text-xs text-foreground-muted mt-0.5">{n.message}</p>
              <p className="text-xs text-foreground-subtle mt-1">{new Date(n.created_at).toLocaleString()}</p>
            </button>
          ))}
        </div>
      )}
    </>
  );

  return (
    <div className="relative" ref={containerRef}>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Notifications"
        className="relative h-9 w-9 flex items-center justify-center rounded-lg text-foreground-muted hover:text-foreground hover:bg-background-elevated transition-colors"
      >
        <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5">
          <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M13.73 21a2 2 0 01-3.46 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        {unreadCount > 0 && (
          <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-danger" />
        )}
      </button>

      {open && (
        <>
          {/* Mobile: fixed full-width sheet — an anchored dropdown would hang
              off whichever side has less room next to the bell and get
              clipped by the viewport edge. */}
          <div className="sm:hidden fixed left-3 right-3 top-16 max-h-[70vh] overflow-y-auto rounded-xl border border-border bg-background-surface shadow-card-hover z-30">
            {panel}
          </div>
          {/* Desktop/tablet: normal anchored dropdown under the bell. */}
          <div className="hidden sm:block absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto rounded-xl border border-border bg-background-surface shadow-card-hover z-20">
            {panel}
          </div>
        </>
      )}
    </div>
  );
}
